module.exports = __webpack_public_path__ + "static/img/honorV30.066a2f21.png";